//Componentes generales
import React, { useState, useMemo, useEffect, useContext } from "react";
import { FixedSizeList } from "react-window";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import AddItm from "../addItm/AddItm";

//Componentes generales
import SearchInput from "../../components/searchInput/SearchInput";
import StateChange from "../../components/StateChange/StateChange";
import SoliInfo from "../SoliInfo/SoliInfo";
import FilterScreen from "../filterScreen/FilterScreen";
import AddFilterSolicitudes from "../../components/addFilterSolicitudes/AddFilterSolicitudes.js";
import ValidDatos from "../../views/ValidDatos/ValidDatos.js";
import RenderRow from "../renderRows/RRSolicitudes";

//Context
import agregarSoliAjusContext from "../../context/agregarSoliAjus/agregarSoliAjusContext.js";
import solicitudesContext from "../../context/solicitudes/solicitudesContext";
import authContext from "../../context/authentication/authContex";
import windowSizeContext from "../../context/windowSize/windowSizeContext";

//Estilos

function SoliList({
  proveedores,
  solicitudes,
  modificarEstado,
  verDetalle,
  filtros,
  aplicarFiltros,
  checkPermisos,
  editar,
  eventoClickEdicion,
  recuperaFilesDetalle,
}) {
  //state para marcar el comprobante seleccionado.
  const [selected, setSelected] = useState("");
  //state para mostrar dialog de Edición.
  const [selectedEdit, setSelectedEdit] = useState("");
  //state para mostrar dialog de cambio de Estado.
  const [selectedState, setSelectedState] = useState("");
  //state para mostrar dialog de filtro.
  const [selectedFilter, setSelectedFilter] = useState("");
  //state para filtros.
  const [filter, setFilter] = useState("");
  //state de workspaces seleccionado (Ya definidos: Pendientes y Autorizados).
  const [activeWorkSpace, setActiveWorkSpace] = useState({
    pendientes: 0,
    cerradas: 0,
    todos: 1,
  });

  /*state para deshabilitar botones hasta que termine de cargar el componente con las solicitudes */
  const [disabledElements, setDisabledElements] = useState(true);
  //state para saber si se modificaron los filtros
  const [filtrosModificados, setFiltrosModificados] = useState(false);
  //state para definir tamaño para lista.
  const [itemSize, setItemSize] = useState(170);

  //state titulo del dialog a utilizar.
  const [title, setTitle] = useState("");

  // Calcula el valor del height según el tamaño de la pantalla y el tamaño del navbar
  const listHeight = useMemo(() => window.innerHeight - 280, []);

  const navigate = useNavigate();

  //Context agregar solicitudes
  const addSoliContext = useContext(agregarSoliAjusContext);
  const { soliAjus, guardarSolicitudAjuste } = addSoliContext;

  //Context solicitudes
  const sContext = useContext(solicitudesContext);
  const { iniciarFiltros } = sContext;

  //Context auth
  const aContext = useContext(authContext);
  const { usuario } = aContext;

  // Calcula el valor del height según el tamaño de la pantalla y el tamaño del navbar
  const wSContext = useContext(windowSizeContext);
  let { height } = wSContext;

  useEffect(() => {
    handlerIniciarlizarFiltros(activeWorkSpace);
  }, []);

  useEffect(() => {
    const workSpace = {
      pendientes: 0,
      cerradas: 0,
      todos: 1,
    };
    setActiveWorkSpace(workSpace);
    handlerIniciarlizarFiltros(workSpace);
  }, [usuario]);

  const handlerIniciarlizarFiltros = async (activeWorkSpace) => {
    setDisabledElements(true);
    await iniciarFiltros(activeWorkSpace, usuario);
    setTimeout(() => {
      setDisabledElements(false);
    }, 1000);
  };

  /* 
        Manejador que setea el  filtro de busqueda.
            Donde data es lo ingresado por el usuario.
    */
  const handdlerSearchInput = (data) => {
    setFilter(data);
  };

  const handlerDetails = async (item) => {
    setSelected(null);
    if (item) {
      const files = await recuperaFilesDetalle(item);
      setSelected({ item, files });
    }
  };

  /* 
        Manejador que abre/cierra el dialog de formulario en modo edición.
    */
  const handlerEdit = async (solicitud) => {
    setSelectedEdit(null);
    if (solicitud) {
      const { files } = await eventoClickEdicion(solicitud);
      const { ...rest } = solicitud;
      setSelectedEdit({ solicitud: { ...rest }, files });
    }
  };

  /* 
        Manejador que abre/cierra el dialog de cambio de estado.
            Donde item es el la solicitud.
    */
  const handlerState = async (item) => {
    setSelectedState(item);
  };

  /* 
        Manejador que abre/cierra el fialog de filtros.
            Donde itm es un booleano que determina si se ve o no.
    */
  const handlerClickFilter = (itm) => {
    setSelectedFilter(itm);
  };

  /* 
        Manejador encargado de abrir en una nueva ventana el archivo seleccionado.
    */
  const handlerAbrirURL = (url) => {
    window.open(url);
  };

  const handleWorkSpace = async (statusToDisplay) => {
    setFilter("");
    let workspaceToSet =
      statusToDisplay == "todos"
        ? { todos: 1, cerradas: 0, pendientes: 0 }
        : statusToDisplay == "cerradas"
        ? { todos: 0, cerradas: 1, pendientes: 0 }
        : { todos: 0, cerradas: 0, pendientes: 1 };
    let estado =
      statusToDisplay == "todos"
        ? ["PENDIENTE", "CERRADA"]
        : statusToDisplay == "pendientes"
        ? ["PENDIENTE"]
        : ["CERRADA"];
    setActiveWorkSpace(workspaceToSet);
    if (filtrosModificados === true) {
      await handlerIniciarlizarFiltros(workspaceToSet);
      setFiltrosModificados(false);
    } else {
      const filterEstado = { ...filtros.filtrosEstado, state: estado };
      const filterRango = filtros.filtrosRango;
      aplicarFiltros({ filterRango, filterEstado }, "");
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          width: "100%",
          marginTop: "-5px",
        }}
      ></div>
      <div className="mainContainerReqList">
        <div className="navbar-reqList">
          <div
            className={`${
              activeWorkSpace.todos
                ? "navbar-container-reqList-active"
                : "navbar-container-reqList"
            } ${disabledElements ? "navbar-container-disabled" : ""}`}
            onClick={() =>
              !disabledElements ? handleWorkSpace("todos") : null
            }
          >
            <div className="navbar-item-reqList">
              <div className="navbar-item-label-xx">TODOS</div>
            </div>
          </div>
          <div
            className={`${
              activeWorkSpace.pendientes
                ? "navbar-container-reqList-active"
                : "navbar-container-reqList"
            } ${disabledElements ? "navbar-container-disabled" : ""}`}
            onClick={() =>
              !disabledElements ? handleWorkSpace("pendientes") : null
            }
          >
            <div className="navbar-item-reqList">
              <div className="navbar-item-label-xx">PENDIENTES</div>
            </div>
          </div>
          <div
            className={`${
              activeWorkSpace.cerradas
                ? "navbar-container-reqList-active"
                : "navbar-container-reqList"
            } ${disabledElements ? "navbar-container-disabled" : ""}`}
            onClick={() =>
              !disabledElements ? handleWorkSpace("cerradas") : null
            }
          >
            <div className="navbar-item-reqList">
              <div className="navbar-item-label-xx">CERRADAS</div>
            </div>
          </div>
        </div>
        <div className="container-requests-list">
          <FilterScreen
            verFiltro={handlerClickFilter}
            disabled={disabledElements}
          />
          <SearchInput defaultValue={filter} buscar={handdlerSearchInput} />
          <FixedSizeList
            height={height - 340}
            style={{ flexGrow: 1 }}
            itemCount={
              filter === ""
                ? solicitudes.length
                : solicitudes.filter(
                    (s) =>
                      s.soliAjusCodFor
                        .toLowerCase()
                        .replace(/\s+/g, "")
                        .includes(filter.toLowerCase().replace(/\s+/g, "")) ||
                      (
                        s.soliAjusCodFor.toLowerCase() +
                        "-" +
                        s.soliAjusNroFor
                          .toString()
                          .toLowerCase()
                          .replace(/\s+/g, "")
                      ).includes(filter.toLowerCase().replace(/\s+/g, "")) ||
                      s.soliAjusNroFor
                        .toString()
                        .toLowerCase()
                        .replace(/\s+/g, "")
                        .includes(filter.toLowerCase().replace(/\s+/g, ""))
                  ).length
            }
            itemSize={itemSize}
            width={"100%"}
          >
            {({ index, style }) => (
              <RenderRow
                usuario={usuario}
                index={index}
                style={style}
                solicitudes={solicitudes}
                filter={filter}
                cambiarEstado={handlerState}
                editar={handlerEdit}
                verDetalles={handlerDetails}
                disabledElements={disabledElements}
              />
            )}
          </FixedSizeList>
        </div>
        {selectedFilter && (
          <div className="modalReq">
            <AddFilterSolicitudes
              usuario={usuario}
              proveedores={proveedores}
              item={selectedFilter}
              cerrar={handlerClickFilter}
              filtro={filtros}
              aplicarFiltros={aplicarFiltros}
              workspace={activeWorkSpace}
              setFiltrosModificados={setFiltrosModificados}
            />
          </div>
        )}
        {selected && (
          <div className="modalReq">
            <SoliInfo
              item={selected.item}
              files={selected.files}
              cerrar={handlerDetails}
              verDetalle={verDetalle}
              abrirURL={handlerAbrirURL}
              guardarModificaciones={modificarEstado}
              usuario={usuario}
            />
          </div>
        )}
        {selectedEdit && (
          <div className="modalReq">
            <ValidDatos
              edicion={"Edicion"}
              item={selectedEdit.solicitud}
              files={selectedEdit.files}
              guardarSolicitud={editar}
              cerrar={handlerEdit}
              verDetalle={verDetalle}
            />
          </div>
        )}
        {selectedState && (
          <div className="modalReq">
            <StateChange
              item={selectedState}
              codFor={selectedState.soliAjusCodFor}
              nroFor={selectedState.soliAjusNroFor}
              guardarEstado={(r, state) => modificarEstado(r, { state: state })}
              cerrar={handlerState}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default SoliList;